import axios from '../axios'

var DashboardProvider = function () {
  return {
    getDashboards (id) {
      return axios.get('dashboards/' + id)
    },

    getCompanies (userId) {
      return axios.get(`dashboards/companies/${userId}`)
    },

    getLastStatus (userId, companyId) {
      return axios.get(`dashboards/laststatus/${userId}/${companyId}`)
    },

    getParentsByCompany (userId, companyId) {
      return axios.get(`dashboards/parents/${userId}/${companyId}`)
    },

    getIncidents (userId, companyId) {
      return axios.get(`dashboards/incidents/${userId}/${companyId}`)
    },

    getIncidentsSearchItems (userId, companyId) {
      return axios.get(`dashboards/incidents/search/${userId}/${companyId}`)
    },

    getDashboardWidgets (userId, companyId) {
      return axios.get(`dashboards/widgets/${userId}/${companyId}`)
    },

    getAssetOverview (userId, companyId) {
      return axios.get(`dashboards/assetoverview/${userId}/${companyId}`)
    },

    getLogicalAssets (userId, companyId, featureId) {
      return axios.get(`dashboards/features/logicalassets/${userId}/${companyId}/${featureId}`)
    },

    getLastStatusSearchItems (userId, companyId) {
      return axios.get(`dashboards/laststatus/search/${userId}/${companyId}`)
    },

    getLastStatusExport (userId, companyId, config = {}) {
      return axios.get(`dashboards/laststatus/export/${userId}/${companyId}`, {
        ...config,
        responseType: 'blob'
      })
    },

    getIncidentsExport (userId, companyId, config = {}) {
      return axios.get(`dashboards/incidents/export/${userId}/${companyId}`, {
        ...config,
        responseType: 'blob'
      })
    },

    getAssetOverviewExport (userId, companyId, config = {}) {
      return axios.get(`dashboards/assetoverview/export/${userId}/${companyId}`, {
        ...config,
        responseType: 'blob'
      })
    },

    getFeatures (userId, companyId) {
      return axios.get(`dashboards/features/${userId}/${companyId}`)
    },

    getFeatureData (userId, companyId, featureId, parentId) {
      return axios.get(`dashboards/features/${userId}/${companyId}/${featureId}?parentId=${parentId}`)
    },

    getFeaturesExport (userId, companyId, featureId, parentId, config = {}) {
      return axios.get(`dashboards/features/export/${userId}/${companyId}/${featureId}?parentId=${parentId}`, {
        ...config,
        responseType: 'blob'
      })
    }
  }
}
export default new DashboardProvider()



// WEBPACK FOOTER //
// ./src/providers/DashboardProvider.js